export enum FeedTypes {
    PermissionFeed,
    HierarchyFeed,
    HierarchyOSHAEstablishmentFeed,
    LookupListFeed,
    OshaEstablishmentFeed,
    ModuleRecordFeed
}